import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    OnDestroy,
    input,
    inject,
    ElementRef,
} from '@angular/core';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ToolbarModule } from '@bazis/shared/components/web/toolbar/toolbar.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';

@Component({
    selector: 'bazis-simple-modal',
    templateUrl: './simple-modal.component.html',
    imports: [CommonModule, ButtonModule, ToolbarModule, ColorDirective, TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleModalComponent implements OnInit, OnDestroy {
    public modalService = inject(BazisModalService);

    readonly message = input<string>('');

    readonly titleKey = input<string>('');

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    closeModal() {
        this.modalService.dismiss();
    }
}
